export const ValueProps = ['247Support', 'tailoredOnboarding', 'freeOnlineTraining'];